
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import OrderMenuCard from './OrderMenuCard.vue';

@Component<SearchResults>({
	components: { OrderMenuCard }
})
export default class SearchResults extends Vue {
	@Prop({ type: String, required: true }) private searchInput!: string;
	@Prop({ type: Array, required: true }) private items!: MenuItem[];
	@Getter('getModifyingOrder', { namespace: 'orders' }) isModifyingOrder!: boolean;
	@Getter('getRestaurant', { namespace: 'auth' }) restaurant!: Restaurant;

	/**
	 * Checks if any item in the menu has an image
	 * * Staff ordering only, not applicable when modifying a generic catering order
	 * * This is due to staff ordering requiring a more condensed view of the menu
	 * * Bowlero does not need images
	 * TODO: Remove the restaurant.group check when all Bowlero locations are ready to use restaurant.groups
	 *
	 * @return {boolean}
	 */
	 private get doesMenuHaveImages(): boolean {
		if (this.restaurant.group === 'bowlero' || this.restaurant.groups?.includes('bowlero')) {
			return false;
		}
		if (this.isModifyingOrder) {
			return true;
		}
		return this.items.some((item: MenuItem) => item.image);
	}
}
